/**
 * Tiny cookie + API-token persistence helpers.
 *
 * Kept framework-free so it can be reused from non-Vue contexts and is
 * trivial to unit-test. The functions were previously inlined inside
 * useFavoritesHandler; extracting them shrinks the reactive closure and
 * makes intent clearer.
 */
export function useCookies() {
    const setCookie = (name, value, days = 365) => {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    };

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    const removeCookie = (name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
    };

    // API token persistence is dual-storage on purpose: the IIFE bundle
    // can be embedded on third-party origins where localStorage may be
    // partitioned or blocked. Cookies act as a fallback sink.
    const saveApiToken = (token) => {
        localStorage.setItem('api_token', token);
        setCookie('api_token', token);
    };

    const clearApiToken = () => {
        localStorage.removeItem('api_token');
        removeCookie('api_token');
    };

    const getApiToken = () => {
        return localStorage.getItem('api_token') || getCookie('api_token') || null;
    };

    return {
        setCookie,
        getCookie,
        removeCookie,
        saveApiToken,
        clearApiToken,
        getApiToken,
    };
}
